"use strict";
/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
tslib_1.__exportStar(require("./service.js"), exports);
tslib_1.__exportStar(require("./container.js"), exports);
tslib_1.__exportStar(require("./blob.js"), exports);
tslib_1.__exportStar(require("./pageBlob.js"), exports);
tslib_1.__exportStar(require("./appendBlob.js"), exports);
tslib_1.__exportStar(require("./blockBlob.js"), exports);
//# sourceMappingURL=index.js.map